function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_756",
  "data-name": "Group 756",
  transform: "translate(13052 5798)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_754",
  "data-name": "Group 754"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_307",
  "data-name": "Rectangle 307",
  transform: "translate(-12779 -5798)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 22,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 23,
  height: 20,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_310",
  "data-name": "Rectangle 310",
  transform: "translate(-12892 -5789)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 18,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 18,
  height: 16,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_311",
  "data-name": "Rectangle 311",
  transform: "translate(-12930 -5797)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 17,
  height: 17,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_314",
  "data-name": "Rectangle 314",
  transform: "translate(-13052 -5795)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 13,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 10,
  height: 11,
  fill: "none"
}))));

var SvgRecGroupL = function SvgRecGroupL(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 27,
    viewBox: "0 0 298 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecGroupL, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/REC_Group_L.8c202346.svg";
export { ForwardRef as ReactComponent };